import React, { useReducer } from 'react'
import XBarContext from './xbarContext'
import { apiCall } from '../../../common/api'
import { response } from '../../common'

import { RESPONSE_STATUS, CLEAR_RESPONSE, GET_PRODUCT } from './xbarTypes'
import XBarReducer from './xbarReducer'

const XBarState = (props) => {
    const initialState = {
        responseStatus: null,
        all_products: {
            record: {},
            from: '',
        },
    }

    const [state, dispatch] = useReducer(XBarReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const retrieveProduct = async (
        formData,
        fromVariable = 'retrieveProduct'
    ) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'retrieveProduct',
                    formData,
                    '',
                    'third_party/xbarcode'
                ),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_PRODUCT,
                    payload: {
                        record: res.data.data.responseData.records
                            ? res.data.data.responseData.records
                            : {},
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, fromVariable)
            } else {
                resp.commonErrorResponse(fromVariable)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <XBarContext.Provider
            value={{
                responseStatus: state.responseStatus,
                all_products: state.all_products,
                retrieveProduct,
                clearResponse,
            }}
        >
            {props.children}
        </XBarContext.Provider>
    )
}

export default XBarState
